// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jbRm","importantInfo":"styles_importantInfo__1esrT"};